// 消息类型常量
export const MESSAGE_TYPE = {
  // 系统通知
  NOTICE: 1,
  // 活动通知
  DISCOUNT: 2,
  // 交易通知
  PAYMENT: 3
} as const

export type MessageType = (typeof MESSAGE_TYPE)[keyof typeof MESSAGE_TYPE]

// 支付消息
export interface MessageNoticeDTO {
  /** ID */
  id: number

  /** 模版内容 */
  templateContent?: string

  /** 模版类型 */
  templateType?: number

  /** 模版参数 */
  templateParams?: PayTemplateParams

  /** 是否已读 */
  readStatus?: boolean

  /** 创建时间 */
  createTime?: string | number

  /** 发送时间 */
  sendTime?: string | number
}

// 支付类型模板
export interface PayTemplateParams {
  title?: string
  currency?: string
  amount?: string | number
  createTime?: string | number
  orderNo?: string | number
  remark?: string
}

// 平台消息 | 优惠通知类型模板
export interface MemberNoticeDTO {
  /** 记录id */
  id: number

  /** 标题 */
  title: string

  /** 内容 */
  content: string

  /** 消息id */
  messageId: number

  /** 是否已读 0-未读 1-已读 */
  readStatus: number

  /** 是否删除 0-未删除 1-已删除 */
  deleteStatus: number

  /** 发送时间 */
  sendTime?: string | number

  /** 创建时间 */
  createTime?: string | number
}

// 未读消息总数
export interface UnreadCount {
  /** 总未读消息数 */
  totalUnreadCount: number

  /** 平台通知未读消息数 */
  platformNoticeUnreadCount: number

  /** 优惠通知未读消息数 */
  discountNoticeUnreadCount: number

  /** 支付通知未读消息数 */
  notifyUnreadCount: number
}

export interface UnreadCountAggResponse {
  platformUnread: { '1': number; '2': number }
  payUnread: number
}

// 统一的消息数据结构（前端格式化后）
export interface NoticeItem {
  id: string
  title: string
  content?: string
  briefContent?: string // 处理后的简要内容（用于列表显示）
  messageId?: number
  readStatus: boolean // 统一为 boolean
  deleteStatus?: number
  time: string // 格式化后的时间字符串
  // 支付消息特有字段
  templateContent?: string
  templateType?: number
  templateParams?: PayTemplateParams
}
